import type { LOCATION_SEARCH_TYPE } from '@/types'

export type GetSelectedChildPositionParams = {
  items: LOCATION_SEARCH_TYPE[]
  selectedId: string
  parentId?: string
}

/**
 * For an indented (airport-nesting) child item, returns the zero-based position
 * of `selectedId` among the children that share the same `parentId`, in the
 * order they appear in `items`. Returns `null` when the child cannot be located
 * — typically because there is no matching parent in the current list.
 */
export function getSelectedChildPosition({
  items,
  selectedId,
  parentId,
}: GetSelectedChildPositionParams): number | null {
  let position = 0
  for (const item of items) {
    if (item.parentId === parentId) {
      if (item.id === selectedId) {
        return position
      }
      position++
    }
  }
  return null
}
